import React from 'react'
import PropTypes from 'prop-types'
import AppBadge from 'shared/badges/app-badge'

// Filters applied outside the groups being edited, one pill per value so names holding commas
// stay apart. See appliedViewFilters.
const AppliedFilterList = ({ appliedFilters, emptyText }) =>
  appliedFilters.length ? (
    <ul className="list-unstyled small mb-0">
      {appliedFilters.map(({ key, label, clauses }) => (
        <li key={key} className="mb-1" data-testid="filter-groups-applied-item">
          <span className="fw-bold">{label}</span>
          {clauses.map(({ verb, values, more }, index) => (
            <span key={`${verb}-${index}`}>
              {index > 0 && ';'} {verb}{' '}
              {values.map((value) => (
                <AppBadge
                  key={value}
                  pill
                  className="bg-light text-primary border fw-normal me-1"
                  data-testid="filter-groups-applied-value"
                >
                  {value}
                </AppBadge>
              ))}
              {more > 0 && <span className="text-muted">+{more} more</span>}
            </span>
          ))}
        </li>
      ))}
    </ul>
  ) : (
    <div className="text-muted small">{emptyText}</div>
  )

AppliedFilterList.propTypes = {
  appliedFilters: PropTypes.array.isRequired,
  emptyText: PropTypes.string.isRequired
}

export default AppliedFilterList
